module.exports = __webpack_public_path__ + "static/img/xm5.ac97e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/xm/xm5.png
// module id = kfj2
// module chunks = 0